import config from '@/config';

export const getS3Url = (): string | undefined => config?.s3Url;
